export const initState = {
	renderType: 'C',

	changedTime: '',

	_currencyList: 'init',
	_coinList: 'init',
	_referredList: 'init',

	currencyLimit: 5,
	coinLimit: 5,
	referredLimit: 5,

	$currencyList: [],
	$coinList: [],
	$referredList: [],

	filteredCurrencyList: [],
	filteredCoinList: [],
	filteredReferredList: [],
};

export default initState;
